import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import Cookies from 'js-cookie';
import { applyRemoteBrandTheme } from '@/brands';
import { store } from '@/store';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { Toaster } from '@/components/common/Toaster';
import '@/styles/globals.css';
import '@fontsource/roboto-condensed';
import '@fontsource/roboto-condensed/300.css';
import '@fontsource/roboto-condensed/400.css';
import '@fontsource/roboto-condensed/700.css';
import { registerSW } from 'virtual:pwa-register';

// Support impersonation: a super admin opens this site with ?__imp=<token>.
// Adopt it as the session cookie and strip it from the URL before anything reads
// auth, so the app boots logged-in as the brand owner. (Backend audits the grant.)
(() => {
  const p = new URLSearchParams(window.location.search);
  const imp = p.get('__imp');
  if (imp) {
    Cookies.set('access-token', imp);
    p.delete('__imp');
    const url = window.location.pathname + (p.toString() ? `?${p}` : '') + window.location.hash;
    window.history.replaceState({}, '', url);
  }
})();

// Paint the build-time brand before first render, then override it with the
// per-domain brand superadmin configured (colors, title, favicon, button colours).
void applyRemoteBrandTheme();

// import DisableDevtool from 'disable-devtool';

// if (import.meta.env.VITE_APP_ENV === 'production') {
//   DisableDevtool();
// }


if (import.meta.env.PROD) {
  // Production: register the PWA service worker as usual
  registerSW({
    onNeedRefresh() {
      console.log('New version available');
    },
    onOfflineReady() {
      console.log('App ready for offline use');
    },
  });
} else {
  // Development: kill any stale service worker + caches so UI changes show instantly
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
  if (typeof caches !== 'undefined') {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
          <Toaster />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
